import m from "../../geodata/es2015/continentsLow";
window.am4geodata_continentsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsLow.js
// module id = null
// module chunks = 